import React, { Component } from 'react';
import cx from 'classnames';
import PlaceholderDark from '../../../../images/placeholder-dark-logo.png';

class MediaThumbnail extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
    };
  }

  thumbClickEvent = () => {
    const { id, handleClick } = this.props;
    if (typeof handleClick === 'function') handleClick(id);
  };

  render() {
    const { loaded } = this.state;
    const {
      id,
      classes,
      height,
      src,
      alt,
      thumbBtns,
      overlayMediaName,
      name,
      dragHandle,
      dragHandleProps,
      tabIndex,
    } = this.props;
    const backgroundSize = Math.round(height / 2);
    const wrapperBackgroundImg = `#fff url(${PlaceholderDark}) center / ${backgroundSize}px no-repeat`;

    return (
      <div
        tabIndex={tabIndex || -1}
        className={`${classes} thumb-wrapper`}
        key={id}
        aria-hidden="true"
        style={{ background: wrapperBackgroundImg }}
        onClick={this.thumbClickEvent}
        onKeyPress={this.thumbClickEvent}
      >
        <img
          style={{
            display: 'block',
            height,
            minHeight: height,
            margin: 'auto',
          }}
          className={cx({ loaded })}
          src={src}
          alt={alt}
          onLoad={() => this.setState({ loaded: true })}
        />
        {overlayMediaName && <span className="stop-name overlay">{name}</span>}
        {typeof thumbBtns === 'function' && (
          <div className="thumb-btn-wrapper">
            {thumbBtns(id)}
            {typeof dragHandle === 'function' && dragHandle(dragHandleProps)}
          </div>
        )}
      </div>
    );
  }
}

export default MediaThumbnail;
